module.exports = __webpack_public_path__ + "h5/img/score.30715cf5.png";